// Shared geometry and active-item styling for every shadcn sidebar rail.

// Semantic UI sets the root font size to 14px, so the primitive's 3rem icon rail
// is 42px, which is too narrow for the 32px icon button plus 8px group padding.
// This is a `style` prop because the primitive sets the variable inline on its
// wrapper.
export const SIDEBAR_STYLE = { "--sidebar-width-icon": "48px" };

// Active item: solid orange fill with white bold text, scoped to `data-active:` so
// the primitive's neutral active classes are overridden only on the selected
// item. Every color has `!` because rail items may render as anchors, and
// Semantic UI's unlayered `a { color }` and normalize's `a { background-color }`
// take precedence over any `@layer utilities` rule.
export const SIDEBAR_MENU_BUTTON_CLASSES =
  "tw:text-sidebar-foreground/70! " +
  "tw:hover:bg-sidebar-accent! " +
  "tw:hover:text-sidebar-accent-foreground! " +
  "tw:data-active:bg-sidebar-primary! " +
  "tw:data-active:font-semibold " +
  "tw:data-active:text-sidebar-primary-foreground! " +
  "tw:data-active:hover:bg-primary-hover! " +
  "tw:data-active:hover:text-sidebar-primary-foreground!";

// Group titles are lighter than the menu items to distinguish them as headers.
// When the rail is collapsed to icons the label is hidden but still overlaps the
// item above it, so its pointer events are disabled or that item cannot be
// clicked.
export const SIDEBAR_GROUP_LABEL_CLASSES =
  "tw:text-sidebar-foreground/50 " +
  "tw:group-data-[collapsible=icon]:pointer-events-none";

// Scroll-fade utilities every rail's content column uses so long menus fade at
// the edges rather than clipping.
export const SIDEBAR_CONTENT_CLASSES = "tw:scroll-fade-4 tw:scroll-fade";

// A section body that fills the content pane as a bounded flex column, so a
// table inside scrolls itself instead of growing the pane into a second
// scroller.
export const SECTION_FILL_CLASSES = "tw:flex tw:min-h-0 tw:flex-1 tw:flex-col";
